import React, { FC } from 'react';

import RouteButtonLink from 'components/common/ui-kit/RouteButtonLink';
import ContractList from 'components/statements/ContractList';
import useAppSelector from 'hooks/common/useAppSelector';
import terms from 'i18n';
import { ApplicationState } from 'models/applications/enum';
import { selectIsUserAdmin } from 'redux/selectors';
import {
  selectApplication,
  selectIsApplicationContractsListReadonly,
} from 'redux/selectors/enrollee/application';
import { useIsImpersonate } from 'utils/domain/impersonate';

const ContractListPage: FC = () => {
  const isImpersonate = useIsImpersonate();
  const isAdmin = useAppSelector(selectIsUserAdmin);
  const application = useAppSelector(selectApplication);

  const isContractListReadOnly =
    (useAppSelector(selectIsApplicationContractsListReadonly) &&
      !isImpersonate) ||
    (!isAdmin && application?.state === ApplicationState.ENROLLED); // https://gitlab.tune-it.ru/polytech/abit/frontend/-/issues/750;;

  return (
    <div>
      <header className="contract-list-page__header">
        <RouteButtonLink
          to="create"
          type="button"
          theme="success"
          disabled={isContractListReadOnly}
        >
          {terms.CREATE_CONTRACT}
        </RouteButtonLink>
      </header>
      <ContractList />
    </div>
  );
};

export default ContractListPage;
